var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('special_message_banner'),(_vm.category_of_product_variety === _vm.MULTI)?_c('Multi_product_homepage'):(_vm.category_of_product_variety === _vm.COUPLE)?_c('Couple_product_page'):_c('Single_product_page')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }